<template>
    <div class="zhuanqu">
        <div>
            <div class="tit">EXCEL专区</div>
            <div>申请{{ fontType }}技巧师</div>
            <div>申请{{ fontType }}红、蓝表验证(免费期)</div>
            <div>申请{{ fontType }}红蓝表付费 (有函数公式可直接申请)</div>
            <div>申请闲置{{ fontType }}EXCEL改表、修复</div>
            <div>定制{{ fontType }}EXCEL表</div>
        </div>
        <div>
            <div class="tit">缩水软件特区<sup>(开发中...)</sup></div>
            <div>{{ fontType }}在线缩水鸠集
                <ul>
                    <li v-for="(item,index) in ulList[lotteryType].ssjj" :key="index">
                        <a :href="item.url">{{ item.name }}</a>
                    </li>
                </ul>
            </div>
            <div>{{ fontType }}在线走势图鸠集
                <ul>
                    <li v-for="(item,index) in ulList[lotteryType].zstjj" :key="index">
                        <a :href="item.url">{{ item.name }}</a>
                    </li>
                </ul>
            </div>
            <div>{{ fontType }}软件免费区</div>
            <div>申请有偿转让{{ fontType }}闲置软件</div>
            <div>申请定制{{ fontType }}软件</div>
        </div>
        <div>
            <div class="tit">实体投注站帮扶中心</div>
            <div>福彩{{ fontType }}实体投注站申请帮扶</div>
            <div>{{ fontType }}实战超市</div>
            <div>{{ fontType }}众筹招股</div>
            <div>{{ fontType }}彩票代表申请</div>
            <div>{{ fontType }}彩票经理申请</div>
        </div>
    </div>
</template>

<script>

export default {
    props: ['lotteryType'],
    data() {
        return {
            fontType: '',
            
            ulList: {
                '0': {
                    ssjj: [
                        {name: '彩经网', url: 'https://tools.cjcp.cn/ssq/'},
                        {name: '彩宝贝', url: 'https://www.78500.cn/tool/ssq.html'},
                        {name: '乐彩网', url: 'https://m.17500.cn/ss-m/ssq.html'},
                        {name: '彩宝网', url: 'https://www.00038.cn/tool/ssq/ssq_ss.aspx'},
                        {name: '天齐网', url: 'https://www.800820.net/zstssq/njbzs.html'},
                    ],
                    zstjj: [
                        {name: '500 彩票', url: 'https://datachart.500.com/ssq/'},
                        {name: '彩经网', url: 'https://zst.cjcp.cn/cjwssq/'},
                        {name: '彩宝贝', url: 'https://www.78500.cn/zs/'},
                        {name: '乐彩网', url: 'https://m.17500.cn/chart-m/index-1-ssq.html'},
                        {name: '彩宝网', url: 'https://www.00038.cn/ssq'},
                        {name: '3D之家', url: 'https://zst.ssqzj.com/cjwssq/view/ssqzonghe.html'},
                        {name: '天齐网', url: 'https://www.800820.net/zstssq/njbzs.html'},
                        {name: '牛彩网', url: 'https://www.cz89.com/zst/ssq'},
                        {name: '浙江风采网', url: 'http://www.fczst.com/down/ssq/dyj02.asp'},
                    ],
                },
                '1': {
                    ssjj: [
                        {name: '彩经网', url: 'https://tools.cjcp.cn/dlt/'},
                        {name: '彩宝贝', url: 'https://www.78500.cn/tool/dlt.html'},
                        {name: '乐彩网', url: 'https://m.17500.cn/ss-m/dlt.html'},
                        {name: '彩宝网', url: 'https://www.00038.cn/dlt/'},
                        {name: '天齐网', url: 'https://www.800820.net/ntooldlt/dltglss.html'},
                    ],
                    zstjj: [
                        {name: '500彩票', url: 'https://datachart.500.com/dlt/'},
                        {name: '彩经网', url: 'https://zst.cjcp.cn/cjwdlt/'},
                        {name: '彩宝贝', url: 'https://www.78500.cn/zs/dlt/'},
                        {name: '乐彩网', url: 'https://m.17500.cn/chart-m/index-1-dlt.html'},
                        {name: '彩宝网', url: 'https://www.00038.cn/dlt/'},
                        {name: '3D之家', url: 'https://zst.ssqzj.com/cjwdlt/view/dltzonghe.html'},
                        {name: '天齐网', url: 'https://www.800820.net/zstdlt/njbzs.html'},
                        {name: '牛彩网', url: 'https://www.cz89.com/zst/dlt'},
                        {name: '浙江风采网', url: 'http://www.fczst.com/down/tc355/'},
                    ]
                },
                '2': {
                    ssjj: [
                        {name: '彩经网', url: 'https://tools.cjcp.cn/gl/3d/'},
                        {name: '彩宝贝', url: 'https://www.78500.cn/tool/3d.html'},
                        {name: '乐彩网', url: 'https://m.17500.cn/ss-m/3d-zhixuan.html'},
                        {name: '彩宝网', url: 'https://www.00038.cn/3d/'},
                        {name: '天齐网', url: 'https://www.800820.net/ntool3d/sdglss.html'},
                    ],
                    zstjj: [
                        {name: '500彩票', url: 'https://datachart.500.com/3d/'},
                        {name: '彩经网', url: 'https://zst.cjcp.cn/cjw3d/'},
                        {name: '彩宝贝', url: 'https://www.78500.cn/zs/3d/'},
                        {name: '乐彩网', url: 'https://m.17500.cn/chart-m/index-1-3d.html'},
                        {name: '彩宝网', url: 'https://www.00038.cn/3d/'},
                        {name: '3D之家', url: 'https://zst.ssqzj.com/cjw3d/view/3dzonghe.html'},
                        {name: '天齐网', url: 'https://www.800820.net/zst3d/njbzs.html'},
                        {name: '牛彩网', url: 'https://www.cz89.com/zst/3d'},
                        {name: '浙江风采网', url: 'http://www.fczst.com/down/tc355/'},
                    ],
                },
                '3': {
                    ssjj: [
                        {name: '彩经网', url: 'https://tools.cjcp.cn/gl/pl3/'},
                        {name: '彩宝贝', url: 'https://www.78500.cn/tool/p3.html'},
                        {name: '乐彩网', url: 'https://m.17500.cn/ss-m/pl3-zhixuan.html'},
                        {name: '彩宝网', url: 'https://www.00038.cn/tool/p3/p3ss.aspx'},
                        {name: '天齐网', url: 'https://www.800820.net/ntoolp3/p3glss.html'},
                    ],
                    zstjj: [
                        {name: '500.com彩票', url: 'https://datachart.500.com/pls/'},
                        {name: '彩经网', url: 'https://zst.cjcp.cn/cjwpls/'},
                        {name: '彩宝贝', url: 'https://www.78500.cn/zs/pls/'},
                        {name: '乐彩网', url: 'https://m.17500.cn/chart-m/index-1-pls.html'},
                        {name: '彩宝网', url: 'https://www.00038.cn/pls/'},
                        {name: '3D之家', url: 'https://zst.ssqzj.com/cjwpls/view/plszonghe.html'},
                        {name: '天齐网', url: 'https://www.800820.net/zstpls/njbzs.html'},
                        {name: '牛彩网', url: 'https://www.cz89.com/zst/pls'},
                        {name: '浙江风采网', url: 'http://www.fczst.com/zst/pl3/'},
                    ],
                }
            }
        }
    },
    mounted() {
        let lotteryType = ['双色球', '大乐透', '3D', '排三'];
        this.fontType = lotteryType[this.lotteryType - 1];
    }
};
</script>

<style lang="scss" scoped>
.zhuanqu {
    display: flex;
    justify-content: space-between;
    
    > div {
        flex: 1;
        border: 1px solid rgba(0, 0, 0, 0.2);
        margin-right: 10px;
        
        > div {
            padding: 0 10px;
            color: #4084b4;
            // font-weight: bold;
            display: flex;
            align-items: center;
            border-bottom: 1px solid rgba(0, 0, 0, 0.2);
            height: 60px;
            position: relative;
            
            &:first-child {
                color: #000000;
                font-size: 21px;
            }
            
            ul {
                display: none;
                position: absolute;
                right: -200px;
                background: cornsilk;
                width: 200px;
                border: 1px solid gray;
                padding: 0;
                list-style: none;
                z-index: 1;
                top: 0;
                margin: 0;
                
                li {
                    height: 40px;
                    line-height: 40px;
                    border-bottom: 1px solid #ccc;
                    
                    a {
                        text-decoration: unset;
                        padding: 0 10px;
                        display: block;
                    }
                }
            }
            
            &:hover {
                background-color: cornsilk;
            }
            
            &:hover ul {
                display: block;
            }
        }
    }
}
</style>